import { Box, CircularProgress, Typography } from "@mui/material";

import type { LoaderProps } from "./types";

// this is actually a fullscreen spinner...
function LoadingSpinner({ size, text }: LoaderProps) {
  return (
    <Box display="flex" flexDirection="column" alignItems="center" justifyContent="center">
      <CircularProgress size={size} />
      {text ? (
        <Typography variant="h6" mt={2}>
          {text}
        </Typography>
      ) : null}
    </Box>
  );
}

export default LoadingSpinner;
